import { render } from "./TelButton.vue?vue&type=template&id=0bd2daea"
import script from "./TelButton.vue?vue&type=script&lang=js"
export * from "./TelButton.vue?vue&type=script&lang=js"

import "./TelButton.vue?vue&type=style&index=0&id=0bd2daea&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__